import React from 'react';
import { useTheme } from '../context/ThemeContext';
import { useAuth } from '../context/AuthContext';
import '../styles/Settings.css';

function Settings() {
  const { isDarkMode, toggleTheme } = useTheme();
  const { user, signInWithGitHub, signOut } = useAuth();

  const handleSignIn = async () => {
    await signInWithGitHub();
  };

  const handleSignOut = async () => {
    await signOut();
  };

  return (
    <div className="settings">
      <h1>Settings</h1>

      {/* Account Section */}
      <div className="settings-section">
        <h2>Account</h2>
        {user ? (
          <div className="account-info">
            <div className="account-detail">
              <label>Profile Picture</label>
              <div className="profile-picture">
                {user.user_metadata?.avatar_url ? (
                  <img
                    src={user.user_metadata.avatar_url}
                    alt={user.user_metadata?.name || 'User'}
                    className="profile-avatar"
                  />
                ) : (
                  <div className="profile-placeholder">
                    {user.user_metadata?.name?.charAt(0) || user.email?.charAt(0) || 'U'}
                  </div>
                )}
              </div>
            </div>
            <div className="account-detail">
              <label>Name</label>
              <p>{user.user_metadata?.name || user.user_metadata?.full_name || 'Not provided'}</p>
            </div>
            <div className="account-detail">
              <label>Email</label>
              <p>{user.email || 'Not provided'}</p>
            </div>
            <div className="account-detail">
              <label>GitHub Username</label>
              <p>{user.user_metadata?.user_name || user.user_metadata?.preferred_username || 'Not available'}</p>
            </div>
            <div className="account-detail">
              <label>Account ID</label>
              <p className="account-id">{user.id}</p>
            </div>
            <div className="account-actions">
              <button onClick={handleSignOut} className="signout-button">
                Sign Out
              </button>
            </div>
          </div>
        ) : (
          <div className="no-account">
            <p>You are not signed in.</p>
            <button onClick={handleSignIn} className="signin-button">
              <svg className="github-icon" viewBox="0 0 24 24" width="20" height="20" fill="currentColor">
                <path d="M12 0C5.37 0 0 5.37 0 12c0 5.31 3.435 9.795 8.205 11.385.6.105.825-.255.825-.57 0-.285-.015-1.23-.015-2.235-3.015.555-3.795-.735-4.035-1.41-.135-.345-.72-1.41-1.23-1.695-.42-.225-1.02-.78-.015-.795.945-.015 1.62.87 1.845 1.23 1.08 1.815 2.805 1.305 3.495.99.105-.78.42-1.305.765-1.605-2.67-.3-5.46-1.335-5.46-5.925 0-1.305.465-2.385 1.23-3.225-.12-.3-.54-1.53.12-3.18 0 0 1.005-.315 3.3 1.23.96-.27 1.98-.405 3-.405s2.04.135 3 .405c2.295-1.56 3.3-1.23 3.3-1.23.66 1.65.24 2.88.12 3.18.765.84 1.23 1.905 1.23 3.225 0 4.605-2.805 5.625-5.475 5.925.435.375.81 1.095.81 2.22 0 1.605-.015 2.895-.015 3.3 0 .315.225.69.825.57A12.02 12.02 0 0024 12c0-6.63-5.37-12-12-12z"/>
              </svg>
              Sign in with GitHub
            </button>
          </div>
        )}
      </div>

      {/* Appearance Section */}
      <div className="settings-section">
        <h2>Appearance</h2>
        <div className="settings-item">
          <label>Dark Mode</label>
          <div className="toggle-switch">
            <input
              type="checkbox"
              id="dark-mode"
              checked={isDarkMode}
              onChange={toggleTheme}
            />
            <span className="toggle-slider"></span>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Settings; 